var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "mt-5" },
    [
      !_vm.selectedStoreName
        ? _c("div", [
            _c("h2", [_vm._v("Select Store Template")]),
            _c("p", { staticClass: "mb-5" }, [
              _vm._v(
                "Select from our library of templates to create your store from."
              ),
            ]),
            _c(
              "button",
              { staticClass: "btn btn-primary", on: { click: _vm.openModal } },
              [_vm._v("Select Template")]
            ),
          ])
        : _c("div", {}, [
            _c("h2", [_vm._v("Selected Template")]),
            _c(
              "div",
              {
                staticClass:
                  "bg-light rounded-lg p-3 d-flex justify-content-between align-items-center",
              },
              [
                _c("strong", [_vm._v(_vm._s(_vm.selectedStoreName))]),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-link ml-2",
                    on: { click: _vm.openModal },
                  },
                  [_vm._v("Change Template")]
                ),
              ]
            ),
          ]),
      _c(
        "b-modal",
        {
          ref: "themes",
          attrs: {
            scrollable: "",
            title: "Store Templates",
            "hide-footer": "",
            "modal-class":
              "modal-fullscreen modal-fullscreen--top border-0 rounded-0",
            "content-class": "border-0 rounded-0",
            "body-class": "p-3 container-max w-100",
          },
        },
        [_c("StoreTemplateList", { on: { select: _vm.handleSelect } })],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }